<twc-popup #popup caption="{{'JOB_SITE.EDIT.TITLE' | translate }}" type="primary" width="l"
    [isDefaultFocusingDisabled]="true">
    <twc-popup-content>
        <form class="twc-form" [formGroup]="form">
            <div class="twc-form-control">
                <label class="twc-form-label">{{ 'JOB_SITE.CREATE.NAME' | translate}}</label>
                <div class="twc-form-element">
                    <input twcInput formControlName="name"
                        placeholder="{{'JOB_SITE.CREATE.PLACEHOLDER_NAME' | translate}}" [maxlength]="nameDescMaxLength"
                        [pattern]="nameRegex" required>
                </div>
            </div>
            <div class="twc-form-control">
                <label class="twc-form-label">{{ 'JOB_SITE.CREATE.DESCRIPTION' |
                    translate}}</label>
                <div class="twc-form-element">
                    <textarea twcTextarea formControlName="description" rows="4" [maxlength]="nameDescMaxLength"
                        placeholder="{{'JOB_SITE.CREATE.PLACEHOLDER_DESCRIPTION' | translate}}"></textarea>
                </div>
            </div>
            <div class="twc-form-control">
                <label class="twc-form-label">{{ 'CREATE_PROJECT.COORDINATE' | translate
                    }}</label>
                <div class="twc-form-element">
                    <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_COORDINATE' | translate}}" type="crs"
                        [selectItem]="form.controls.horizProjectionEPSG.value" [floating]="true"
                        (selectItemChange)="setSelectedCRS($event)"></cw-crs-search>
                </div>
            </div>

            <div class="twc-form-control">
                <label class="twc-form-label">{{ 'JOB_SITE.CREATE.DATA_TYPE' | translate}}</label>
                <div class="twc-form-element">
                    <twc-radio *ngFor="let option of snapshotTypeOptions" [inline]="true">
                        <input twcRadioInput type="radio" formControlName="snapshotType" [value]="option.value">
                        <label twcRadioLabel>{{'JOB_SITE.CREATE.' + option.label | translate}}</label>
                    </twc-radio>
                </div>
            </div>

            <div class="twc-form-control">
                <label class="twc-form-label">{{ 'JOB_SITE.CREATE.DISTANCE' | translate}}</label>
                <div class="twc-form-element">
                    <input twcInput cwNumberDecimals formControlName="sampleDistance" min="0" required type="number">
                </div>
            </div>
        </form>

        <twc-checkbox class="twc-mt-4">
            <input twcCheckboxInput [checked]="isUpdateConfirmed" (click)="toggleConfirmation()"
                [disabled]="!areSummaryValuesChanged">
            <label twcCheckboxLabel>{{ 'JOB_SITE.EDIT.CONFIRMATION' | translate }}</label>
        </twc-checkbox>
    </twc-popup-content>


    <twc-popup-footer>
        <button class="twc-button twc-button-link" (click)="popup.onClose()">{{ 'GENERAL.CANCEL' | translate }}</button>
        <!-- TODO: Workaround until TWC fixed the disabled property -->
        <button class="twc-button twc-button-primary" [twcLoading]="loading" (click)="updateJobSite()"
            [attr.disabled]="!isSaveEnabled() || null">{{'JOB_SITE.EDIT.SAVE' |
            translate }}</button>
    </twc-popup-footer>
</twc-popup>